import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AuthService } from '@kpd/framework-ngx';
import { apiUrl } from 'environments/environment';
import { Application } from 'app/shared/models/application';
import { Observable } from 'rxjs';

export interface IApplicationDTO {
  description: string;
  name: string;
}

@Injectable()
export class ApplicationService {
  constructor(private httpClient: HttpClient, private authService: AuthService) {}

  get tenant(): string {
    return this.authService.getTenant().key.toString();
  }

  getApplicationsByTenant(): Observable<Application[]> {
    return this.httpClient
      .get<IApplicationDTO[]>(`${apiUrl()}/tenants/${this.tenant}/applications`)
      .pipe(map(applicationDTO => applicationDTO.map(dto => new Application(dto))));
  }
}
